module.exports = __webpack_public_path__ + "img/title-4.288aef64.png";